import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import ERROR_MESSAGE from '@/constants/errors.constants';
import { documentoSchema } from '@/helpers/validationsDocuments';
import { type IDocumentoForm } from '@/interfaces/model/don.interface';


export type Form = {
	nifEmisor: string;
	idError: number;
	idTramite: number;
	idTipoError: number;
	numeroTramite: string;
	fechaCreacion: string;
	observacionesPeticion: string;
	tipoDocumento: string;
	observacionesEmisor: string;
	documento?: IDocumentoForm;
	documentoErroneo?: IDocumentoForm;
	notAvaliableDoc: Array<'true'>;
};

export const defaultValues = {
	nifEmisor: '',
	numeroTramite: '',
	fechaCreacion: undefined,
	observacionesPeticion: '',
	tipoDocumento: '',
	observacionesEmisor: '',
	documento: undefined,
	documentoErroneo: undefined,
	notAvaliableDoc: [],
};

export const schema = yup.object().shape({
	documento: documentoSchema().when('notAvaliableDoc', {
		is: (val: Form['notAvaliableDoc']) => Boolean(val?.includes('true')),
		then: (schema) => schema.nullable(),
		otherwise: (schema) => schema.required(ERROR_MESSAGE.docRequired),
	}),
	observacionesEmisor: yup.string().when('notAvaliableDoc', {
		is: (val: Form['notAvaliableDoc']) => Boolean(val?.includes('true')),
		then: (schema) => schema.required(ERROR_MESSAGE.required),
		otherwise: (schema) => schema.nullable(),
	}),
});

export const getSchema = (): Resolver<any> => yupResolver(schema);